import api from './api';

// Проверяем, что переменная окружения загружена
if (!process.env.REACT_APP_IONET_API_KEY) {
  console.error('IONET_API_KEY is not defined in environment variables');
}

const IONET_API_KEY = process.env.REACT_APP_IONET_API_KEY || 'io-v2-eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJvd25lciI6Ijg0Nzc4ZjFlLWZmMjktNGMzYy1hNjg4LTljNmNhYTg5NzQ5ZSIsImV4cCI6NDg5ODQ4NTYzOX0.GglXpHXKRFYJvmnGNGGcOPDs8izbx7Oco5dGHKE9pUiHAvcVol78f0hzBuWMkmdMdn2yJRp4POpLYGK0lXitGA';

const IONET_API_URL = 'https://api.intelligence.io.solutions/api/v1';

export const generateProductDescription = async (product) => {
  try {
    // Проверяем наличие необходимых данных
    if (!product) {
      throw new Error('Продукт не определен');
    }
    
    if (!product.name) {
      throw new Error('Название продукта не определено');
    }

    if (!product.game) {
      throw new Error('Категория игры не определена');
    }

    const prompt = `Сгенерируй краткое описание для чита "${product.name}" для игры "${product.game}". 
    Продукт имеет следующие функции: ${product.features.map(f => f.name).join(', ')}.
    Описание должно быть профессиональным, убедительным и привлекательным для потенциальных покупателей.
    Используй маркетинговый язык, но без преувеличений.
    Описание должно быть на русском языке.
    Длина описания должна быть около 75-150 слов.
    Описание должно быть одним абзацем, без разбивки на части.
    Не используй заголовки и подзаголовки.
    Начни описание со слов ${product.name} для ${product.game} - это".
    В описании НЕ используй другие названия игр, кроме "${product.game}".
    В описании НЕ упоминай другие игры или жанры.`;

    console.log('Using API Key:', IONET_API_KEY);
    console.log('Product game:', product.game);

    const response = await fetch(`${IONET_API_URL}/chat/completions`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${IONET_API_KEY}`
      },
      body: JSON.stringify({
        model: 'ozone-ai/0x-lite',
        messages: [
          {
            role: 'system',
            content: 'Ты - профессиональный копирайтер, специализирующийся на описании игровых продуктов. Пиши кратко, но убедительно. Используй ТОЛЬКО указанное название игры.'
          },
          {
            role: 'user',
            content: prompt
          }
        ],
        temperature: 0.7,
        max_tokens: 500
      })
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('API Error:', errorText);
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }

    const data = await response.json();
    if (!data.choices || !data.choices[0]?.message?.content) {
      throw new Error('Неверный формат ответа от API');
    }

    return data.choices[0].message.content.trim();
  } catch (error) {
    console.error('Error generating description:', error);
    throw new Error(error.message || 'Не удалось сгенерировать описание. Попробуйте позже.');
  }
}; 